import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Image from '@base/Image';
import { useIsMobile } from '@stores/AppCommonData';
import { Spacings, Fonts, mobile } from '../../../../styleConstants';
import SectionTitle from '../SectionTitle';
import SummitDate from '../SummitDate';
import RegisterButton from '../RegisterButton';
import ContentContainer from '../ContentContainer';

const Wrapper = styled.section`
  display: grid;
  grid-template: 1fr / 1fr max-content;
  grid-column-gap: 200px;
  @media only screen and (max-width: ${mobile.maxWidth}) {
    display: block;
    text-align: center;
    margin-top: 120px;
  }
`;

const InfoContainer = styled.div``;

const StyledTitle = styled(SectionTitle)`
  margin-bottom: ${Spacings.SPACING_2B};
`;

const ImageWrapper = styled.div`
  position: relative;
  height: 252px;
  width: 465px;
  align-self: center;
  @media only screen and (max-width: ${mobile.maxWidth}) {
    width: 320px;
    height: 200px;
    margin-top: ${Spacings.SPACING_4B};
  }
`;

const StyledButton = styled(RegisterButton)`
  @media only screen and (max-width: ${mobile.maxWidth}) {
    margin-left: auto;
    margin-right: auto;
  }
`;

const SummitFooter = ({ scheduleRef }) => {
  const isMobileDevice = useIsMobile();
  const staticTexts = useSelector(({ summit }) => summit.staticTexts || {});
  return (
    <ContentContainer as={Wrapper}>
      <InfoContainer>
        <StyledTitle $size={isMobileDevice ? Fonts.H2 : Fonts.H1}>
          {staticTexts.footerHeader || ''}
        </StyledTitle>
        {isMobileDevice && (
          <ImageWrapper>
            <Image
              src="summit/footer_bg.svg"
              alt="take the summit advantage"
              layout="fill"
            />
          </ImageWrapper>
        )}
        <SummitDate />
        <StyledButton scheduleRef={scheduleRef} />
      </InfoContainer>
      {!isMobileDevice && (
        <ImageWrapper>
          <Image
            src="summit/footer_bg.svg"
            alt="take the summit advantage"
            layout="fill"
          />
        </ImageWrapper>
      )}
    </ContentContainer>
  );
};

SummitFooter.propTypes = {
  scheduleRef: PropTypes.objectOf(PropTypes.object).isRequired
};

export default SummitFooter;
